'use strict'

import Vue from 'vue'
import axios from 'axios'
import store from './store'
import router from './router'

const vm = new Vue()
const baseUrl = ""

axios.interceptors.request.use(
    (config) => {
        return config
    },
    (error) => {
        // console.log(error)
        vm.$message.error("请求错误")
    }
)

axios.interceptors.response.use(
    (res) => {
        // console.log(res)
        store.state.loginState = false
        let obj = res.data
        if (res.config.url.startsWith('/device/idCode')) {
            store.commit(vm.$mutation.LOGIN_TIMEOUT, false)
            return res.data
        }
        else if (res.config.url.startsWith('/deviceMirror/downloadDeviceMirrorLogFile')) {
            return res
        }
        if (obj.success) {
            store.commit(vm.$mutation.LOGIN_TIMEOUT, false)
            return res.data
        } else {
            if (obj.code === '10105') {
                if (!store.state.loginTimeout) {
                    store.commit(vm.$mutation.LOGIN_TIMEOUT, true)
                    vm.$message.error("登录状态过期")
                }
                store.commit("LOGIN_FORWARD_PATH", router.currentRoute.path)
                router.push("/")
            } else if (obj.code === '10016') {
                store.commit(vm.$mutation.IS_NEED_LICENSE, true)
            } else if (obj.code === "10025") {
                // console.log("白名单校验失败[api]")
                store.commit(vm.$mutation.LOGIN_ERROR, obj.message)
                router.push('/ipForbidden')
            }
            // else {
            //     let mes = obj.message || "请求失败"
            //     vm.$message.error(mes)
            // }
            return Promise.reject(obj.message)
        }
    },
    (error) => {
        // console.log(error)
        vm.$message.error("请求错误")
        store.state.loginState = false
        return Promise.reject(error)
    }
)

export const postData = (url, params) => {
    url = url.path || url
    // console.log(baseUrl+url)
    return axios.post(baseUrl + url, params, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...store.state.userInfo,
            userId: store.state.userInfo.id
        },
        transformRequest: [function (data) {
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
            // return Qs.stringify({...data})
        }]
    })
}
